import React, { useState } from 'react';
import WebIcon from '@/assets/icon-web.svg?react';

interface FaviconProps {
  src: string;
  className?: string;
}

const Favicon: React.FC<FaviconProps> = ({ src, className }) => {
  const [result, setResult] = useState<{ src: string; ok: boolean } | null>(null);

  const loaded = result?.src === src && result.ok;
  const failed = result?.src === src && !result.ok;

  return (
    <>
      {(!loaded || failed) && <WebIcon />}
      {!failed && (
        <img
          src={src}
          alt=""
          // d-none images still load; this only avoids a flash of an empty box.
          className={`${className ?? ''} ${!loaded ? 'd-none' : ''}`}
          referrerPolicy="no-referrer"
          onLoad={() => setResult({ src, ok: true })}
          onError={() => setResult({ src, ok: false })}
        />
      )}
    </>
  );
};

export default Favicon;
